import { ActionTree } from 'vuex';
import { RootState, SingleFilter } from '@/store/types';
import { SectionAccessState } from './types';
import SectionAccess from '@/api/models/section-access';
import { SectionAccessResource } from '@/api/requests/types';
import * as sectionAccessRequests from '@/api/requests/section-accesses';
import api from '@/api';

export const actions: ActionTree<SectionAccessState, RootState> = {

    // Section Accesses
    
    /**
     * Fetch all accesses.
     * @param commit
     */
    async fetchSectionAccesses({ commit, getters }) {
        const response = await api.call(sectionAccessRequests.ALL(getters.httpFilters));
        commit('setSectionAccesses', response.data.data);
    },

    /**
     * Store the access to a section.
     *
     * @param commit
     * @param sectionAccess
     */
    async createSectionAccess({ commit }, data: {sectionAccess: SectionAccess, password: string}) {
        let request = data.sectionAccess.toRequest();
        request.password = data.password;
        const response = await api.call(sectionAccessRequests.STORE(request));
        const resource: SectionAccessResource = response.data.data;

        commit('addSectionAccess', resource);
    },

     /**
     * Filters
     * Reset a single filter.
     * @param commit
     * @param key
     */
    resetFilter({ commit, dispatch }, key: string) {
        commit('resetFilter', key);
        dispatch('fetchSectionAccesses');
    },

    /**
      * Reset all filters.
      * @param commit
      */
    resetFilters({ commit, dispatch }) {
        commit('resetFilters');
        dispatch('fetchSectionAccesses');
    },

     /**
     * Set filters.
     * @param commit
     * @param filters
     */
     setFilters({ commit, dispatch }, filters: SingleFilter[]) {
        filters.map((filter) => commit('setFilter', filter));
        dispatch('fetchSectionAccesses');
    },

};
